import { createSlice } from '@reduxjs/toolkit';
import { ExcelLogListApi, lithosExcelLogListApi } from '../services/api';

export const LithosExcelLogSlice = createSlice({
	name: 'lithosExcelLog',
	initialState: {
		isLoading: false,
		excelLogList: [],
		error: null,
	},
	reducers: {
		setLoading: (state) => {
			state.isLoading = true;
		},

		excelLogData: (state, action) => {
			state.isLoading = false;
			state.excelLogList = action.payload;
		},

		excelLogErrorList: (state, action) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const { setLoading, excelLogData, excelLogErrorList } = LithosExcelLogSlice.actions;

export default LithosExcelLogSlice.reducer;

export const lithosExcelLogListRequest = (queryString) => async (dispatch, getState) => {
	dispatch(setLoading());
	try {
		const config = {
			headers: {
				'Content-Type': 'application/json',
				Authorization: getState()?.auth?.Token,
			},
		};
		const { data } = await lithosExcelLogListApi(queryString, config);

		dispatch(excelLogData(data));
	} catch (error) {
		dispatch(excelLogErrorList(error));
	}
};
